module.exports = __webpack_public_path__ + "img/thumbnail.b194591c.jpg";